const ErrorText = ({ error }) => {
  return <span className="text-danger"> {error} </span>;
};

export default ErrorText;
